import {
  percentFormatter,
} from "src/utils/functions/helpers";

export const tableColumns = {
  name: "Název fondu/služby",
  m1: "m1",
  m3: "m3",
  m6: "m6",
  y1: "y1",
  ytd: "ytd",
  y3: "y3",
  y5: "y5",
  all: "all",
  y1Pa: "y1Pa",
  y3Pa: "y3Pa",
  y5Pa: "y5Pa",
  allPa: "allPa",
};

const getPercent = (number: number | null): string => {
  if (number !== null && typeof number === "number")
    return percentFormatter().format(number || 0);
  else return "- -";
};

export const getPortfolioData = (portfolioData: any) => {
  if (portfolioData) {
    const perf = portfolioData.performance;
    return {
      name: portfolioData.productId,
      m1: getPercent(perf?.m1),
      m3: getPercent(perf?.m3),
      m6: getPercent(perf?.m6),
      y1: getPercent(perf?.y1),
      ytd: getPercent(perf?.ytd),
      y3: getPercent(perf?.y3),
      y5: getPercent(perf?.y5),
      all: getPercent(perf?.all),
      y1Pa: getPercent(perf?.y1Pa),
      y3Pa: getPercent(perf?.y3Pa),
      y5Pa: getPercent(perf?.y5Pa),
      allPa: getPercent(perf?.allPa),
    };
  }
};

export const getInstrumentsData = (data: any) => {
  if (data) {
    const perf = data.performance;
    return {
      name: data.productId,
      m1: getPercent(perf?.m1),
      m3: getPercent(perf?.m3),
      m6: getPercent(perf?.m6),
      y1: getPercent(perf?.y1),
      ytd: getPercent(perf?.ytd),
      y3: getPercent(perf?.y3),
      y5: getPercent(perf?.y5),
      all: getPercent(perf?.all),
      y1Pa: getPercent(perf?.y1Pa),
      y3Pa: getPercent(perf?.y3Pa),
      y5Pa: getPercent(perf?.y5Pa),
      allPa: getPercent(perf?.allPa),
    };
  }
};

export const getServicesData = (data: any) => {
  if (data) {
    const perf = data.performance;
    return {
      name: data.serviceId,
      m1: getPercent(perf?.m1),
      m3: getPercent(perf?.m3),
      m6: getPercent(perf?.m6),
      y1: getPercent(perf?.y1),
      ytd: getPercent(perf?.ytd),
      y3: getPercent(perf?.y3),
      y5: getPercent(perf?.y5),
      all: getPercent(perf?.all),
      y1Pa: getPercent(perf?.y1Pa),
      y3Pa: getPercent(perf?.y3Pa),
      y5Pa: getPercent(perf?.y5Pa),
      allPa: getPercent(perf?.allPa),
    };
  }
};
